// @ts-nocheck


import { fetchRequest } from './index';

import CommonApi from '../commonApi';
import { convertFromHourToSecond, convertFromSecondToHour } from '../pure/unitConversions';

export const convertDataToServer = (
attachedEquipment) =>
{
  return {
    ...attachedEquipment,
    machineHoursAtStart: convertFromHourToSecond(
      attachedEquipment.machineHoursAtStart
    ),
    machineHoursAtEnd: convertFromHourToSecond(
      attachedEquipment.machineHoursAtEnd
    )
  };
};

export const convertDataFromServer = (
attachedEquipment) => (
{
  ...attachedEquipment,
  machineHoursAtStart: convertFromSecondToHour(
    attachedEquipment.machineHoursAtStart
  ),
  machineHoursAtEnd: convertFromSecondToHour(
    attachedEquipment.machineHoursAtEnd
  )
});

const basedUrl = 'tripAttachedEquipment';
const vehiclePlan = new CommonApi(
  basedUrl,
  'путевой лист наверсное оборудование',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...vehiclePlan
};